import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public router: Router
  ) { }

  getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }

  public loginUser() {
    this.router.navigate(["/enetassess"]);
  }

  public logoutAssessor() {
    window.location.href = "login?al=1";
  }

  public logoutAnonymousCandidate() {
    window.location.href = "login?cl=1";
  }

  public goToEnetassess() {
    this.router.navigate(["/enetassess"]);
  }

  public goToFeedback(){
    this.router.navigate(["/feedback"]);
  }

  public logoutUser(enetsecure) {
    if(enetsecure !== null && enetsecure !== undefined && enetsecure !== ""){
      window.location.href = "login?" + enetsecure;
    }    
    else{
      window.location.href = "login";
    }
  }

  public logoutMockUser(mockId) {
    window.location.href = "login?mock=1&mid=" + mockId;
  }

  public launchExam() {
    //update schedule candidate status in db
    this.router.navigate(["/loadexam"]);
  }

  public launchExamQuestions() {
    this.router.navigate(["/questions"]);
  }
}
